import React from "react";
import { blogCardData } from "./Blog";
import { useParams } from "react-router-dom";

const BlogCardDetail = () => {
  const param = useParams();
  console.log(param.id);
  // console.log(selectBlog);
  const selectBlog = blogCardData[param.id - 1];

  return (
    <section className="mt-20 bg-white pt-4 pb-8 sm:pb-12 w-full flex flex-col items-center rounded-lg max-w-7xl mx-auto">
      <div className="flex flex-col items-center shadow-md justify-center py-5 px-6 mx-4  lg:mx-24 rounded-lg w-[-webkit-fill-available]">
        <h1 className="mt-4 text-2xl font-bold text-center mb-2 sm:text-3xl md:text-4xl lg:text-5xl mx-auto text-gray-900">
          {" "}
          {selectBlog.heading}
        </h1>
        {/* <p className="text-gray-600 my-2 mb-4"> {selectBlog.subHeading}</p> */}
        <img
          src={selectBlog.cardImg}
          alt="card pic"
          className="w-full max-h-[510px] h-auto mt-4 rounded-lg object-cover"
        />
        <p className="w-[-webkit-fill-available]" dangerouslySetInnerHTML={{
          __html: selectBlog.imgDesc}}></p>
        {/* <p className="text-gray-700 leading-normal md:leading-relaxed my-2 text-lg">
          In the ever-evolving landscape of data management, SQL Server
          continues to be a cornerstone for businesses aiming to manage and
          analyze their data efficiently. As we approach 2024, SQL Server Data
          Tools (SSDT) are more relevant than ever, offering enhanced features
          that streamline database development and management. Whether you're a
          seasoned database professional or just starting, understanding the
          latest updates to SSDT can significantly impact your data solutions.
          This guide will walk you through the key features of SQL Server Data
          Tools for 2024 and explain why they are essential for your
          organization.
        </p>
        <div className="flex flex-col justify-start text-lg border-b border-gray-200 pb-14">
          <h4 className="text-gray-900 font-medium text-lg md:text-2xl lg:text-3xl flex justify-start my-1 sm:my-2 md:my-4">
            What Are SQL Server Data Tools?
          </h4>
          <p className="text-gray-700 leading-normal md:leading-relaxed my-1">
            SQL Server Data Tools (SSDT) are a set of tools that integrate
            seamlessly with Visual Studio, enabling developers to design,
            develop, and deploy SQL Server databases. SSDT simplifies database
            development by providing a comprehensive environment for creating
            and managing databases, data warehouses, and business intelligence
            solutions.
          </p>
          <h4 className="text-gray-900 font-medium text-lg md:text-2xl lg:text-3xl flex justify-start my-1 sm:my-2 md:my-4">
            Key Features of SQL Server Data Tools for 2024
          </h4>
          <p className="text-gray-700 text-lg leading-normal md:leading-relaxed my-1 ">
            As SQL Server continues to evolve, SSDT has introduced several new features and improvements for 2024. Let’s delve into some of the most impactful updates:          </p>
          <ul className="list-disc pl-6 sm:pl-8 text-gray-800">
            <li className="text-gray-600 leading-normal md:leading-relaxed mb-2">
              <span className="text-gray-800 font-medium mr-2 text-lg">
                {" "}
                Improved Database Project Management:
              </span>
              SSDT 2024 has enhanced support for database projects, making it
              easier to manage complex database schemas. This improvement allows
              developers to handle large-scale projects more efficiently,
              ensuring better organization and version control.
            </li>
            <li className="text-gray-600 leading-normal md:leading-relaxed mb-2">
              <span className="text-gray-800 font-medium mr-2 text-lg">
                {" "}
                Improved Database Project Management:
              </span>
              SSDT 2024 has enhanced support for database projects, making it
              easier to manage complex database schemas. This improvement allows
              developers to handle large-scale projects more efficiently,
              ensuring better organization and version control.
            </li>
            <li className="text-gray-600 leading-normal md:leading-relaxed mb-2">
              <span className="text-gray-800 font-medium mr-2 text-lg">
                {" "}
                Improved Database Project Management:
              </span>
              SSDT 2024 has enhanced support for database projects, making it
              easier to manage complex database schemas. This improvement allows
              developers to handle large-scale projects more efficiently,
              ensuring better organization and version control.
            </li>
            <li className="text-gray-600 leading-normal md:leading-relaxed mb-2">
              <span className="text-gray-800 font-medium mr-2 text-lg">
                {" "}
                Improved Database Project Management:
              </span>
              SSDT 2024 has enhanced support for database projects, making it
              easier to manage complex database schemas. This improvement allows
              developers to handle large-scale projects more efficiently,
              ensuring better organization and version control.
            </li>
            <li className="text-gray-600 leading-normal md:leading-relaxed mb-2">
              <span className="text-gray-800 font-medium mr-2 text-lg">
                {" "}
                Improved Database Project Management:
              </span>
              SSDT 2024 has enhanced support for database projects, making it
              easier to manage complex database schemas. This improvement allows
              developers to handle large-scale projects more efficiently,
              ensuring better organization and version control.
            </li>
          </ul>
          <p className="text-2xl my-2 mb-4  font-medium text-gray-800">
            Benefits of Using SQL Server Data Tools in 2024
          </p>
          <img src={selectBlog.cardImg} alt="card img " className="w-full " />
          <p className="text-gray-700 my-2"> Adopting Microsoft SQL Server Data Tools for 2024 brings several advantages:</p>
          <ul className="list-decimal pl-8 ">
            <li className="text-gray-600 leading-normal md:leading-relaxed mb-2">
              <span className="text-gray-800 font-semibold mr-2 text-lg">
                {" "}
                Improved Database Project Management:
              </span>
              SSDT 2024 has enhanced support for database projects, making it
              easier to manage complex database schemas. This improvement allows
              developers to handle large-scale projects more efficiently,
              ensuring better organization and version control.
            </li>            <li className="text-gray-600 leading-normal md:leading-relaxed mb-2">
              <span className="text-gray-800 font-semibold mr-2 text-lg">
                {" "}
                Improved Database Project Management:
              </span>
              SSDT 2024 has enhanced support for database projects, making it
              easier to manage complex database schemas. This improvement allows
              developers to handle large-scale projects more efficiently,
              ensuring better organization and version control.
            </li>            <li className="text-gray-600 leading-normal md:leading-relaxed mb-2">
              <span className="text-gray-800 font-medium mr-2 text-lg">
                {" "}
                Improved Database Project Management:
              </span>
              SSDT 2024 has enhanced support for database projects, making it
              easier to manage complex database schemas. This improvement allows
              developers to handle large-scale projects more efficiently,
              ensuring better organization and version control.
            </li>            <li className="text-gray-600 leading-normal md:leading-relaxed mb-2">
              <span className="text-gray-800 font-medium mr-2 text-lg">
                {" "}
                Improved Database Project Management:
              </span>
              SSDT 2024 has enhanced support for database projects, making it
              easier to manage complex database schemas. This improvement allows
              developers to handle large-scale projects more efficiently,
              ensuring better organization and version control.
            </li>

          </ul>
          <h4 className="text-lg md:text-2xl lg:text-3xl text-gray-800 my-1 sm:my-2"> Why Choose DirectDeals for Your SQL Server Needs?</h4>
          <p className="text-gray-600">DirectDeals is committed to helping you achieve your data management goals with the latest SQL Server tools. Whether you're looking to upgrade to the newest SQL Server version, need guidance on optimizing your databases, or seek comprehensive software solutions, DirectDeals is your go-to partner. Our extensive range of SQL Server products, including the latest SQL Server Data Tools for 2024, is backed by our dedication to exceptional customer service and technical support.</p>
          <p className="text-lg text-gray-700 mt-4">
            For all your SQL Server needs, contact DirectDeals today. Let us help you harness the power of SQL Server Data Tools and ensure your data solutions are built for the future.
          </p>
          <p className="text-gray-400 text-sm mt-4 text-center sm:mt-8">
            This entry was posted in Microsoft Office, Quick Tips, SQL Server.
          </p>
        </div>
        <div className="flex justify-center mt-12">
          <p className="shadow-lg px-12 py-8  border text-center border-gray-100 w-4/5 text-gray-600">
            If you feel that you've received this message in error, please click here for more information.
          </p>

        </div> */}
      </div>
    </section>
  );
};

export default BlogCardDetail;
